import {toast} from "react-hot-toast";

export const confirmToast = (message, onConfirm) => {
    toast((t) => (
        <div
            className="flex flex-col gap-4 p-6 bg-white rounded-2xl shadow-2xl border border-gray-100 min-w-[320px] max-w-md">
            {/* Icon */}
            <div className="flex justify-center">
                <div
                    className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
                    </svg>
                </div>
            </div>

            {/* Message */}
            <div className="text-center">
                <p
                    className="text-gray-800 font-medium text-lg leading-relaxed"
                >
                    {message}
                </p>
            </div>

            {/* Buttons */}
            <div className="flex justify-center gap-3 mt-2">
                <button
                    className="px-6 py-2.5 rounded-xl font-medium text-gray-600 bg-gray-50 hover:bg-gray-100 border border-gray-200 transition-all duration-200 hover:scale-105 hover:shadow-md active:scale-95"
                    onClick={() => toast.dismiss(t.id)}
                >
                    Cancel
                </button>
                <button
                    className="px-6 py-2.5 rounded-xl font-medium text-white bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transition-all duration-200 hover:scale-105 hover:shadow-lg active:scale-95 shadow-md"
                    onClick={() => {
                        toast.dismiss(t.id);
                        onConfirm();
                    }}
                >
                    Confirm
                </button>
            </div>
        </div>
    ), {
        duration: Infinity,
        position: "top-center",
        style: {
            background: 'transparent',
            boxShadow: 'none',
            padding: 0,
        },
    });
};